var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Panel", {
    staticStyle: { "margin-top": "1em" },
    attrs: { collapsible: "" },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [_vm._v("\n        Cluster members\n    ")]
          },
          proxy: true,
        },
        {
          key: "toolbar-extra",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  attrs: {
                    plain: "",
                    href: `${_vm.$axios.defaults.baseURL}/cluster/${
                      _vm.$route.params.cluster
                    }/members?format=summary&${_vm.requestOptions.params.toString()}`,
                    target: "_blank",
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v(_vm._s(_vm.$MDI.Export)),
                  ]),
                  _vm._v("\n            Export\n        "),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        _vm.$route.params.cluster
          ? {
              key: "content",
              fn: function () {
                return [
                  _c("Sankey", {
                    attrs: { cluster: _vm.cluster, type: "members" },
                    on: { select: _vm.sankeySelect },
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.members,
                      options: _vm.options,
                      "server-items-length": _vm.totalMembers,
                      loading: _vm.loading,
                      "footer-props": {
                        "items-per-page-options": [10, 20, 50, 100, -1],
                      },
                    },
                    on: {
                      "update:options": function ($event) {
                        _vm.options = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.accession",
                          fn: function (prop) {
                            return [
                              _c("ExternalLinks", {
                                attrs: {
                                  accession: prop.item.pdb_id.toUpperCase(),
                                  reference: "PDB",
                                  simple: "",
                                },
                              }),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "caption text--darken-1",
                                  staticStyle: {
                                    display: "inline-block",
                                    "max-width": "220px",
                                    "white-space": "nowrap",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "vertical-align": "bottom",
                                  },
                                  attrs: { title: prop.item.description || "" },
                                },
                                [_vm._v(_vm._s(prop.item.description))]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.chains",
                          fn: function (prop) {
                            return [
                              _c("div", [_vm._v(_vm._s(prop.item.chain1))]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(prop.item.chain2))]),
                            ]
                          },
                        },
                        {
                          key: "item.uniprot",
                          fn: function (prop) {
                            return [
                              _c("div", [
                                prop.item.uniprot_id1 !== null
                                  ? _c(
                                      "span",
                                      [
                                        _c("ExternalLinks", {
                                          attrs: {
                                            accession: prop.item.uniprot_id1,
                                            simple: "",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v("N/A")]),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                prop.item.uniprot_id2 !== null
                                  ? _c(
                                      "span",
                                      [
                                        _c("ExternalLinks", {
                                          attrs: {
                                            accession: prop.item.uniprot_id2,
                                            simple: "",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v("N/A")]),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "header.structure",
                          fn: function ({ header }) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(header.text) +
                                  "\n            "
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "span",
                                              _vm._g({}, on),
                                              [
                                                _c("v-icon", _vm._g({}, on), [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$MDI.HelpCircleOutline
                                                    )
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      "\n                   Click on a structure to superpose its interface on to the cluster representative in the structure viewer\n                "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.structure",
                          fn: function (prop) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple",
                                      value: { class: `primary--text` },
                                      expression: "{ class: `primary--text` }",
                                    },
                                  ],
                                  staticStyle: {
                                    "text-align": "center",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit(
                                        "select",
                                        prop.item.accession
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { height: "75px" },
                                    attrs: {
                                      src: _vm.getImage(prop.item.accession),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.flag",
                          fn: function (prop) {
                            return [
                              _c("ClusterLevel", {
                                attrs: { flag: prop.value },
                              }),
                            ]
                          },
                        },
                        {
                          key: "header.flag",
                          fn: function ({ header }) {
                            return [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "offset-y": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    outlined:
                                                      _vm.options.flagFilter !=
                                                      null,
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(header.text) +
                                                    " \n                        "
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                _vm._g({}, on),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      {},
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .$MDI
                                                                            .HelpCircleOutline
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _c("img", {
                                                        attrs: {
                                                          width: "600",
                                                          src: require("./assets/interface_cluster_workflow.png"),
                                                        },
                                                      }),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                                Member: Members from either dimer or interface clustering "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                                Dimer Rep.: Clustered with dimer structural similarity "
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                                Interface Rep.: Clustered with interface structural similarity "
                                                      ),
                                                      _c("br"),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    {
                                      staticStyle: {
                                        padding: "2em",
                                        width: "250px",
                                      },
                                    },
                                    [
                                      _c("h3", [_vm._v("Filter by")]),
                                      _vm._v(" "),
                                      _c(
                                        "v-chip-group",
                                        {
                                          attrs: { column: "" },
                                          model: {
                                            value: _vm.options.flagFilter,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.options,
                                                "flagFilter",
                                                $$v
                                              )
                                            },
                                            expression: "options.flagFilter",
                                          },
                                        },
                                        [
                                          _c("ClusterLevel", {
                                            attrs: { flag: 1 },
                                          }),
                                          _vm._v(" "),
                                          _c("ClusterLevel", {
                                            attrs: { flag: 2 },
                                          }),
                                          _vm._v(" "),
                                          _c("ClusterLevel", {
                                            attrs: { flag: 3 },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "header.tax_id",
                          fn: function ({ header }) {
                            return [
                              _c("TaxonomyAutocomplete", {
                                attrs: {
                                  cluster: _vm.cluster,
                                  urlFunction: (a, b) =>
                                    "/cluster/" + a + "/members/taxonomy/" + b,
                                  options: _vm.requestOptions,
                                  disabled: _vm.taxAutocompleteDisabled,
                                },
                                model: {
                                  value: _vm.options.tax_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.options, "tax_id", $$v)
                                  },
                                  expression: "options.tax_id",
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.tax_id",
                          fn: function (prop) {
                            return [
                              prop.item.tax_id1 && prop.item.tax_id1.name
                                ? _c(
                                    "div",
                                    { staticClass: "text-caption" },
                                    [
                                      _c("TaxSpan", {
                                        attrs: { taxonomy: prop.item.tax_id1 },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", { staticClass: "text-caption" }, [
                                    _vm._v("N/A"),
                                  ]),
                              _vm._v(" "),
                              prop.item.tax_id2 && prop.item.tax_id2.name
                                ? _c(
                                    "div",
                                    { staticClass: "text-caption" },
                                    [
                                      _c("TaxSpan", {
                                        attrs: { taxonomy: prop.item.tax_id2 },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", { staticClass: "text-caption" }, [
                                    _vm._v("N/A"),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    title: "Search with Foldseek",
                                    href:
                                      "https://search-dev.foldseek.com/interface?accession=" +
                                      item.pdb_id +
                                      "&source=PDB",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src: require("./assets/marv-foldseek-small.png"),
                                      "max-width": "16",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1163544172
                    ),
                  }),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }